import React from 'react';
import { motion } from 'framer-motion';
import { SectionTag } from './SectionTag';
import { CONTENT_IMAGE, CONTENT_TEXTURES, EASY_BENEFITS } from './salesData';

/**
 * FACILIDAD + QUÉ VAS A APRENDER, fusionadas en una sola sección.
 * Responde la primera objeción ("no sé hacerlo") y, sin repetir argumentos,
 * resume todo el contenido en 4 beneficios. El bloque visual original se
 * conserva íntegro: fotografía grande + las tres miniaturas de proceso.
 */
export function EasySection() {
  return <section id="aprendes" className="scroll-mt-24 bg-cream py-11 sm:py-16" aria-labelledby="easy-title" data-id="element-96" data-mp="2qgkipu4lek3j">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-97" data-mp="2v8m3k4fttj56">
        <div className="max-w-3xl" data-id="element-98" data-mp="2za7a781rp16x">
          <SectionTag data-id="element-99" data-mp="2z960p80egmrb">Sin experiencia previa</SectionTag>
          <h2 id="easy-title" className="mt-4 font-display text-[1.95rem] leading-[1.06] text-charcoal sm:text-[2.7rem]" data-id="element-100" data-mp="349agswxebfh0">
            No necesitás ser experto en repostería
          </h2>
          <p className="mt-4 font-sans text-[0.95rem] leading-relaxed text-charcoal-mid" data-id="element-101" data-mp="2w5j5ak4c9y2r">
            Aunque nunca hayas preparado New York Cookies, vas a poder avanzar con recetas
            organizadas paso a paso. Y si querés ir más allá de cocinar en casa, también vas a tener
            una base de 100 recetas para crear tu propio catálogo y empezar a ofrecerlas.
          </p>
        </div>

        <div className="mt-7 grid gap-8 lg:grid-cols-12 lg:gap-12" data-id="element-102" data-mp="3etwjzdxk6ea4">
          {/* Bloque visual original: la foto grande + las tres miniaturas. */}
          <div className="lg:col-span-6" data-id="element-103" data-mp="3avqiakbkuow2">
            <motion.figure initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.3
          }} transition={{
            duration: 0.32,
            ease: [0.23, 1, 0.32, 1]
          }} className="overflow-hidden rounded-5xl shadow-bakery" data-id="element-104" data-mp="361m7tr33ryq8">
              <img src={CONTENT_IMAGE} alt="Bandeja llena de cookies gruesas recién horneadas con chocolate fundido encima." loading="lazy" decoding="async" className="aspect-[4/3] w-full object-cover" data-id="element-105" data-mp="3tqxchjnkqd9n" />
            </motion.figure>

            <ul className="mt-4 grid grid-cols-3 gap-3 sm:gap-4" data-id="element-106" data-mp="7oybkt2ym2wy">
              {CONTENT_TEXTURES.map((texture, index) => <motion.li key={texture.id} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              amount: 0.4
            }} transition={{
              duration: 0.26,
              ease: [0.23, 1, 0.32, 1],
              delay: index * 0.04
            }} data-id="element-107" data-mp="3txg4hqn3vzld" data-mpi={index}>
                  <img src={texture.image} alt={texture.alt} loading="lazy" decoding="async" className="aspect-square w-full rounded-3xl object-cover shadow-bakery-sm" data-id="element-108" data-mp="1j6zjm6h9psf1" />
                </motion.li>)}
            </ul>
          </div>

          {/* Los 4 beneficios que absorben todo lo que antes estaba repartido. */}
          <ul className="lg:col-span-6 lg:self-center" data-id="element-109" data-mp="3hh83pmmbm81t">
            {EASY_BENEFITS.map((benefit, index) => <motion.li key={benefit.id} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.4
          }} transition={{
            duration: 0.28,
            ease: [0.23, 1, 0.32, 1],
            delay: Math.min(index, 3) * 0.035
          }} className="flex items-start gap-4 border-b border-warm py-4 first:border-t sm:gap-5 sm:py-5" data-id="element-110" data-mp="3rdjg0clwuxw9" data-mpi={index}>
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-caramel-pale font-sans text-[0.66rem] font-bold tabular-nums text-[#F47A2A] sm:h-10 sm:w-10 sm:text-[0.74rem]" data-id="element-111" data-mp="211n98m15uzgp">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <div data-id="element-112" data-mp="2cgqc4nev4qrg">
                  <h3 className="font-display text-[1.05rem] leading-tight text-charcoal sm:text-[1.3rem]" data-id="element-113" data-mp="2cg70tpjpx0me">
                    {benefit.title}
                  </h3>
                  <p className="mt-1.5 max-w-xl font-sans text-[0.86rem] leading-snug text-charcoal-mid sm:leading-relaxed" data-id="element-114" data-mp="1jrt7vo7hkuhp">
                    {benefit.body}
                  </p>
                </div>
              </motion.li>)}
          </ul>
        </div>
      </div>
    </section>;
}